module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"base":{"avatar":{"user_avatar":"%{name}\u0027s Benutzerbild"}}}}}}')
  delete Component.options._Ctor
}
